import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useQuery } from 'react-query';

import { crmConstants } from '..';

export const useCrmFacebookRedirectUrl = (props: { pipeId?: number } = {}) =>
  useQuery<string>({
    queryKey: [crmConstants.queryKeys.CRM_FACEBOOK_REDIRECT_URL, props],
    queryFn: async () => {
      const res = await $api.get(
        stringifyUrl({
          url: '/v1/crm/facebook/redirect-url',
          query: {
            pipeId: props.pipeId
          }
        })
      );

      return res?.data?.data;
    },
    enabled: !!props?.pipeId
  });
